export const CornerFrame = ({ color = "#BACD1C" }) => (
  <>
    <span className="pointer-events-none absolute top-0 left-0 h-3.5 w-3.5 border-t border-l" style={{ borderColor: color }} />
    <span className="pointer-events-none absolute top-0 right-0 h-3.5 w-3.5 border-t border-r" style={{ borderColor: color }} />
    <span className="pointer-events-none absolute bottom-0 left-0 h-3.5 w-3.5 border-b border-l" style={{ borderColor: color }} />
    <span className="pointer-events-none absolute bottom-0 right-0 h-3.5 w-3.5 border-b border-r" style={{ borderColor: color }} />
  </>
);
